export const rejectionsHandler = (sessionExpired) => (error, { dispatch, rejectWithValue }) => {
  if (error?.response?.status === 401) {
    dispatch(sessionExpired());
  }

  return rejectWithValue(error);
};
